import classnames from "classnames";

import { Text } from "components/ui/source";
import { propertyStandards } from "components/ui/source/components/SonderStandards/content";

import IconText from "../../IconText";

import styles from "./TopStandards.module.scss";

interface TopStandardsProps {
  standardsCount?: number;
  className?: string;
}

export default function TopStandards({
  className,
  standardsCount = 4,
}: TopStandardsProps) {
  const standardElements = Object.entries(propertyStandards)
    .slice(0, standardsCount)
    .map(([name, { Icon, translateKey }], i) => (
      <div key={name + i} data-testid="top-standard-element">
        <IconText
          Icon={Icon}
          title={translateKey}
          titleTextProps={{ className: styles.title }}
        />
      </div>
    ));

  return (
    <div className={classnames(className, styles.container)}>
      <Text
        className={styles.feature_title}
        types={["caption1"]}
        translateKey="listing:intro.standards"
      />
      {standardElements}
    </div>
  );
}
